import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3 break-url" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "mb-2 break-url" }
const _hoisted_6 = { class: "mb-2 break-url" }
const _hoisted_7 = { class: "mb-3 break-url" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_10 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_13 = { class: "text-caption text-medium-emphasis mb-1" }
const _hoisted_14 = {
  key: 0,
  class: "text-error"
}
const _hoisted_15 = {
  key: 0,
  class: "text-body-2 mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDialog) = $event)),
    "max-width": "760",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Review External Server", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1,
                    __: [4]
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1,
            __: [5]
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_ctx.submitError)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    density: "compact",
                    class: "mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.submitError), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Server Key", -1)),
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.draft?.name), 1),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Display Name", -1)),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.draft?.displayName), 1),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "URL", -1)),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.draft?.url), 1),
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Auth Mode", -1)),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.draft?.authMode), 1),
              (_ctx.draft?.authMode === 'oauth2' && _ctx.draft?.oauthTemplate)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Authorization Provider", -1)),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.draft.oauthTemplate.authorizationServerIssuer || _ctx.draft.oauthTemplate.authorizationEndpoint), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Authorization:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.draft.oauthTemplate.authorizationEndpoint), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Token:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.draft.oauthTemplate.tokenEndpoint), 1)
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Registration Mode", -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.registrationModeLabel), 1),
                    (_ctx.resolvedScopes.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Scopes", -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.resolvedScopes.join(', ')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showManualCredentialInputs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.installClientId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.installClientId) = $event)),
                            label: "Client ID",
                            variant: "outlined",
                            class: "mb-3"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.installClientSecret,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.installClientSecret) = $event)),
                            label: "Client Secret",
                            variant: "outlined",
                            class: "mb-3"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.installScopesValue,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.installScopesValue) = $event)),
                            label: "Scopes Override",
                            hint: "Comma-separated optional scopes.",
                            "persistent-hint": "",
                            variant: "outlined"
                          }, null, 8, ["modelValue"])
                        ]))
                      : (_ctx.draft.oauthTemplate.registrationMode === 'cimd' || _ctx.draft.oauthTemplate.registrationMode === 'dcr')
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 2,
                            type: "info",
                            density: "compact",
                            variant: "tonal",
                            class: "mb-3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.draft.oauthTemplate.registrationMode === 'cimd'
                ? 'This shared definition uses automatic client identity. Manual client credentials are intentionally unavailable for later installs.'
                : 'This shared definition uses automatic client registration. Manual client credentials are intentionally unavailable for later installs.'), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Secret Field Names", -1)),
                _createElementVNode("div", null, _toDisplayString(_ctx.secretFieldNames), 1)
              ]),
              (_ctx.secretFields.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "User Secrets", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secretFields, (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field.name,
                        class: "mb-3"
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createTextVNode(_toDisplayString(field.label) + " ", 1),
                          (field.required)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        (field.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(field.description), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.installSecretValues[field.name],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.installSecretValues[field.name]) = $event),
                          label: field.label,
                          type: "password",
                          variant: "outlined",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_alert, {
                type: "info",
                variant: "tonal",
                density: "compact"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" This server definition will be visible to other MissionSquad users. Your secrets and OAuth credentials will remain private to your account. ")
                ])),
                _: 1,
                __: [13]
              })
            ]),
            _: 1,
            __: [14,15,16,17]
          }),
          _createVNode(_component_v_card_actions, { class: "px-4 pb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1,
                __: [18]
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                loading: _ctx.submitting,
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("Confirm")
                ])),
                _: 1,
                __: [19]
              }, 8, ["loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}